import {
    HIDE_MESSAGE,
    INIT_URL,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SIGNIN_USER_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    SIGNUP_USER_SUCCESS,
    SERVER_LOGIN,
    SERVER_LOGIN_WITH_TOKEN,
    SERVER_LOG_OUT,
    SERVER_RESTORE_PASSWORD,
    RESET_RESTORE_PASSWORD_SUCCESS_FLAG,
    SERVER_GENERATE_RECOVERY_KEY,
    SERVER_SET_RECOVERY_PASSWORD
} from 'constants/ActionTypes';

export const userSignIn = (userName, password) => {
    return {
        type: SERVER_LOGIN,
        payload: { userName, password }
    };
};

export const userSignOut = () => {
    return {
        type: SERVER_LOG_OUT
    };
};
export const signInWithToken = token => {
    return {
        type: SERVER_LOGIN_WITH_TOKEN,
        payload: { token }
    };
};

export const restorePassword = userName => {
    return {
        type: SERVER_RESTORE_PASSWORD,
        payload: { userName }
    };
};

export const resetRestorePasswordSuccess = () => {
    return {
        type: RESET_RESTORE_PASSWORD_SUCCESS_FLAG
    };
};

export const userSignUpSuccess = authUser => {
    return {
        type: SIGNUP_USER_SUCCESS,
        payload: authUser
    };
};

export const userSignInSuccess = authUser => {
    return {
        type: SIGNIN_USER_SUCCESS,
        payload: authUser
    };
};
export const userSignOutSuccess = () => {
    return {
        type: SIGNOUT_USER_SUCCESS
    };
};

export const showAuthMessage = message => {
    return {
        type: SHOW_MESSAGE,
        payload: message
    };
};

export const setInitUrl = url => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const showAuthLoader = () => {
    return {
        type: ON_SHOW_LOADER
    };
};

export const hideMessage = () => {
    return {
        type: HIDE_MESSAGE
    };
};
export const hideAuthLoader = () => {
    return {
        type: ON_HIDE_LOADER
    };
};

export const generateRecoveryKey = username => {
    return { type: SERVER_GENERATE_RECOVERY_KEY, payload: { username } };
};

export const setRecoveryPassword = (userId, key, password) => {
    return { type: SERVER_SET_RECOVERY_PASSWORD, payload: { userId, key, password } };
};



// WEBPACK FOOTER //
// ./actions/Auth.js